import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@mui/material';
import BoardCanvas from 'boardCanvas/BoardCanvas';
import { DEFAULT_BOARDS_BY_TYPE } from 'PopularBoards';
import React, { useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { BoardType, Units } from 'Types';

import { getBoardTypes } from 'boardClasses/BoardFactory';
import { useCreateNewBoard } from 'state/recoilBoardActions';
import { isNewModalOpenAtom, settingsAtom } from 'state/recoilState';
import useRouter from 'utils/useRouter';

function NewButtonModal() {
  const settings = useRecoilValue(settingsAtom);
  const [isNewModalOpen, setIsNewModalOpen] =
    useRecoilState(isNewModalOpenAtom);

  const createNewBoard = useCreateNewBoard();

  const router = useRouter();

  const [newBoardType, setNewBoardType] = useState(BoardType.Strips);

  const onNewBoardTypeChange = (
    _event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => setNewBoardType(value as BoardType);

  const newBoardDefault = DEFAULT_BOARDS_BY_TYPE[newBoardType];

  const onNewBoardCreate = () => {
    const params =
      newBoardDefault.units === Units.IN && settings.units === Units.MM
        ? newBoardDefault.scaleParams(newBoardDefault.params, 25.4)
        : newBoardDefault.params;

    const newBoard = newBoardDefault
      .duplicate()
      .updateParams(params)
      .updateUnits(settings.units);

    createNewBoard(newBoard);

    setIsNewModalOpen(false);

    router.navToBoardID(newBoard.id);
  };

  const onClose = () => {
    setIsNewModalOpen(false);
  };

  return (
    <Dialog
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={isNewModalOpen}
      onClose={onClose}
    >
      <DialogTitle>New Board</DialogTitle>

      <DialogContent>
        <Grid container spacing={2}>
          <Grid item>
            <FormControl component="fieldset">
              <FormLabel component="legend">Choose a board type</FormLabel>
              <RadioGroup
                aria-label="Gender"
                value={newBoardType}
                onChange={onNewBoardTypeChange}
              >
                {getBoardTypes().map((className) => (
                  <FormControlLabel
                    control={<Radio />}
                    key={className}
                    label={className}
                    value={className}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: 400,
                width: 360,
              }}
            >
              <BoardCanvas
                dimensions={newBoardDefault.getDimensions()}
                renderables={newBoardDefault.getRenderables()}
                scaleFactor={24}
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onNewBoardCreate} color="primary">
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NewButtonModal;
